import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { Reveal } from './Reveal';
const HERO_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/ad55f85e-1f32-429d-ab30-6bb3680b5353.jpg';
const POINTS = ['Armada berkualitas, bersih & nyaman', 'Tim profesional & berpengalaman', 'Melayani pribadi maupun perusahaan', 'Perjalanan aman dan menyenangkan'];
export function About() {
  return <section id="tentang" className="relative bg-ink-soft py-24" data-id="element-13" data-mp="33q6rc7265qur">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 lg:grid-cols-2" data-id="element-14" data-mp="38q300jlta6gn">
        <Reveal className="order-2 lg:order-1" data-id="element-15" data-mp="3dh1erer5iwhs">
          <div className="mb-4 flex items-center gap-3" data-id="element-16" data-mp="3dicjphwc2aah">
            <span className="h-px w-8 bg-gold/60" data-id="element-17" data-mp="3hiemxvhpvbrv" />
            <span className="text-xs font-medium uppercase tracking-[0.3em] text-gold" data-id="element-18" data-mp="3hi4tfxxgqmhf">Tentang Kami</span>
          </div>
          <h2 className="font-display text-3xl font-bold leading-tight sm:text-4xl md:text-5xl" data-id="element-19" data-mp="3mfwnaxho4io9">
            Rental Mobil Terpercaya <span className="text-gold-gradient" data-id="element-20" data-mp="2lqz4uce6cwqp">di Garut</span>
          </h2>
          <p className="mt-6 text-sm leading-relaxed text-white/65 sm:text-base" data-id="element-21" data-mp="2louqf0ingfc6">
            PT Wardah Pratama Transport merupakan perusahaan penyedia jasa rental mobil terpercaya
            di Garut yang melayani kebutuhan transportasi pribadi maupun perusahaan. Kami berkomitmen
            memberikan pelayanan terbaik dengan armada berkualitas, bersih, nyaman, serta didukung oleh
            tim profesional untuk memastikan perjalanan Anda aman dan menyenangkan.
          </p>

          <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-22" data-mp="30gwtsujxhqgy">
            {POINTS.map(p => <li key={p} className="flex items-start gap-3 text-sm text-white/80" data-id="element-23" data-mp="2vnkb111xkdw4">
                <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-gold" data-id="element-24" data-mp="2qpsiq5xdipre" />
                {p}
              </li>)}
          </ul>
        </Reveal>

        <Reveal delay={0.15} className="order-1 lg:order-2" data-id="element-25" data-mp="3jefw7fbvsaue">
          <div className="relative" data-id="element-26" data-mp="3jcwjfypfohxd">
            <div className="overflow-hidden rounded-3xl gold-border" data-id="element-27" data-mp="65bxtapcni3s">
              <img src={HERO_IMG} alt="Armada mewah WP Transport" className="h-full w-full object-cover" data-id="element-28" data-mp="b4x6icubn4tp" />
            </div>
            <div className="absolute -bottom-6 -left-6 hidden rounded-2xl border border-gold/30 bg-ink px-6 py-5 shadow-xl sm:block" data-id="element-29" data-mp="3tjfwpx6eaufx">
              <div className="font-display text-3xl font-bold text-gold-gradient" data-id="element-30" data-mp="1dkdvj0p8amm">100%</div>
              <div className="text-xs uppercase tracking-wider text-white/60" data-id="element-31" data-mp="3jjys7j2vqmlj">Kepuasan Pelanggan</div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}